import "./ConsentModalFooter.scss";

type ConsentModalFooterProps = {
  children?: React.ReactNode;
};

export const ConsentModalFooter = ({ children }: ConsentModalFooterProps) => {
  return (
    <footer className="ui-consent-modal-footer bg-white shadow">
      {children}
    </footer>
  );
};
